"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFilteredBgProps = exports.getFilteredProps = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var getFilteredProps = function getFilteredProps(_ref) {
  var _ref$config = _ref.config,
      config = _ref$config === void 0 ? {} : _ref$config,
      _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? '' : _ref$alt,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      src = _ref.src,
      sizes = _ref.sizes,
      width = _ref.width,
      height = _ref.height,
      params = _ref.params,
      otherProps = _objectWithoutProperties(_ref, ["config", "alt", "className", "src", "sizes", "width", "height", "params"]);

  return _objectSpread({
    alt: alt,
    className: className,
    imgNodeWidth: width,
    imgNodeHeight: height
  }, otherProps);
};

exports.getFilteredProps = getFilteredProps;

var getFilteredBgProps = function getFilteredBgProps(_ref2) {
  var _ref2$config = _ref2.config,
      config = _ref2$config === void 0 ? {} : _ref2$config,
      _ref2$alt = _ref2.alt,
      alt = _ref2$alt === void 0 ? '' : _ref2$alt,
      _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? '' : _ref2$className,
      src = _ref2.src,
      sizes = _ref2.sizes,
      width = _ref2.width,
      height = _ref2.height,
      params = _ref2.params,
      otherProps = _objectWithoutProperties(_ref2, ["config", "alt", "className", "src", "sizes", "width", "height", "params"]);

  return _objectSpread({
    alt: alt,
    className: className
  }, otherProps);
};

exports.getFilteredBgProps = getFilteredBgProps;